<template>
  <b-container fluid class="RwvArticleList">
    <h1 v-if="title">{{title}}</h1>
    <!-- ToDo: Add Spinner -->
    <div class="articles">
      <div
        v-for="article in articlesWithAds"
        :key="article.slug">
          <RwvArticleTile
            v-if="article.ad_client == null"
            :article="article">
          </RwvArticleTile>
          <InFeedAdsense
            v-else
            :data-ad-layout-key="article.layout_key"
            :data-ad-client="article.ad_client"
            :data-ad-slot="article.ad_slot">
        </InFeedAdsense>
      </div>
      <!-- <VPagination :pages="pages" :currentPage.sync="currentPage" /> -->
    </div>

    <!-- <b-spinner variant="success" label="Spinning"></b-spinner> -->
    <div class="text-center my-2" v-if="isLoading">
      <b-spinner variant="success" type="grow" label="Spinning"></b-spinner>
      <!-- <div class="article-preview">Artikel werden geladen...</div> -->
    </div>
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
import RwvArticleTile from "@/components/Articles/ArticleTile";
import VPagination from "@/components/VPagination";
import {
  FETCH_ARTICLES,
  FETCH_ARTICLES_COUNT,
  FETCH_BLOG,
  FETCH_BLOG_COUNT,
  FETCH_VIDEOS,
  FETCH_VIDEOS_COUNT
} from "@/store/actions.type";
export default {
  name: "RwvArticleList",
  props: {
    title: {
      type: String,
      required: false,
    },
    category: {
      type: String,
      required: false,
      default: ""
    },
    type: {
      type: String,
      required: false,
      default: "all"
    },
    authorSlug: {
      type: String,
      required: false
    },
    tag: {
      type: String,
      required: false
    },
    manufacturerSlug: {
      type: String,
      required: false
    },
    modelSlug: {
      type: String,
      required: false
    },
    variantSlug: {
      type: String,
      required: false
    },
    favorited: {
      type: String,
      required: false
    },
    itemsPerPage: {
      type: Number,
      required: false,
      default: 20
    }
  },
  data() {
    return {
      currentPage: 1
    };
  },
  components: {
    RwvArticleTile,
    VPagination
  },
  computed: {
    listConfig() {
        // skip: (this.currentPage - 1) * this.itemsPerPage,
        // limit: this.itemsPerPage,
      const params = {
        include: [
          {
            relation: "variants",
            scope: {
              include: {
                relation: "model"
              }
            }
          }
        ],
        fields: {
          urls: false,
          isLightTheme: false,
          createdAt: false,
          updatedAt: false,
          image: false
        }
      }
      const offset = (this.currentPage - 1) * this.itemsPerPage;
      return params
    },
    pages() {
      if (this.isLoading || this.count <= this.itemsPerPage) {
        return [];
      }
      return [
        ...Array(Math.ceil(this.count / this.itemsPerPage)).keys()
      ].map(e => e + 1);
    },
    filterdArticles() {
      // var me = this;
      // var articlesToDisplay = [];

      // if (me.manufacturerSlug || me.authorSlug) {
      //   return me.articles.filter(function (article) {
      //     // filter articles variants
      //     var variantApplies = true
      //     var authorApplies = true

      //     if (me.authorSlug) {
      //       article.authorSlug = me.authorSlug
      //     }

      //     if (me.manufacturerSlug) {
      //       var variants = article.variants.filter(function(variant) {
      //         console.log(variant)
      //         if (me.variantSlug) {
      //           return variant.slug == me.variantSlug
      //         } else if (me.modelSlug) {
      //           return variant.modelSlug == me.modelSlug
      //         } else {
      //           return variant.model.manufacturerSlug == me.manufacturerSlug
      //         }
      //       })
      //       variantApplies = (variants.length > 0)
      //     }

      //     return variantApplies && authorApplies;
      //   });
      // } else {
        var articles = []

        if (this.category == "article") {
          articles = this.articles
        } else if (this.category == "blog") {
          articles = this.blog
        } else if (this.category == "video") {
          articles = this.videos
        } else {
          console.log("default list")
          articles = this.articles
        }

        return articles
      // }
    },
    articlesWithAds() {
      // Batch is at the time of writing at 9, so this will insert ads at the beginning, the middle and the end.
      // first ad at index 0
      var articles = JSON.parse(JSON.stringify(this.filterdArticles))

      var articlesLength =  articles.length

        articles.unshift({
          slug: "ad-top",
          ad_client: "ca-pub-0281378002600422",
          ad_slot: "2976302612",
          layout_key: "-ey+67+9w-g4-3j"
        })

      // big -e3+9c-2f-go+12w
      // medium -ey+67+9w-g4-3j -> Right font
      // small -gh+1u+7a-2p-7d

      if (articlesLength >= 4) {
        var index =  4 + 1 // + 1 because of existing ad

        articles.splice(index, 0, {
          ad_client: "ca-pub-0281378002600422",
          ad_slot: "2976302612"
        });

        if (articlesLength >= 8) {
          index = 8 + 2 // + 2 because of existing ad

          articles.splice(index, 0, {
            ad_client: "ca-pub-0281378002600422",
            ad_slot: "2976302612"
          });
        }
      }
      return articles
    },
    isLoading() {
      if (this.category == "article") {
        return this.isLoadingArticles
      } else if (this.category == "blog") {
        return this.isLoadingBlog
      } else if (this.category == "video") {
        return this.isLoadingVideos
      } else {
        console.log("default list")
        return this.isLoadingArticles
      }
    },
    count() {
      if (this.category == "article") {
        return this.articlesCount
      } else if (this.category == "blog") {
        return this.blogCount
      } else if (this.category == "video") {
        return this.videosCount
      } else {
        console.log("default list")
        return this.articlesCount
      }
    },
    ...mapGetters([
      "articlesCount",
      "isLoadingArticles",
      "articles",
      "blogCount",
      "isLoadingBlog",
      "blog",
      "videosCount",
      "isLoadingVideos",
      "videos",
      "defaultParamsArticles"
      ])
  },
  watch: {
    currentPage(newValue) {
      // this.listConfig.skip = (newValue - 1) * this.itemsPerPage;
      this.fetchArticles();
    },
  },
  created () {
    window.addEventListener('scroll', this.scroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.scroll);
  },
  mounted() {
      if (this.category == "article") {
        this.$store.dispatch(FETCH_ARTICLES_COUNT);
      } else if (this.category == "blog") {
        this.$store.dispatch(FETCH_BLOG_COUNT);
      } else if (this.category == "video") {
        this.$store.dispatch(FETCH_VIDEOS_COUNT);
      } else {
        console.log("default list")
        this.$store.dispatch(FETCH_ARTICLES_COUNT);
      }
    this.fetchArticles();
  },
  methods: {
    fetchArticles() {

      // if (this.category == "" ) {
      //   console.log("default")
      //   this.defaultParamsArticles.where = {
      //     "category": "article"
      //   }
      // } else {
      //   this.defaultParamsArticles.where = {
      //     "category": this.category
      //   }
      // }

      if (this.category == "article") {
        this.$store.dispatch(FETCH_ARTICLES);
      } else if (this.category == "blog") {
        this.$store.dispatch(FETCH_BLOG);
      } else if (this.category == "video") {
        this.$store.dispatch(FETCH_VIDEOS);
      } else {
        console.log("default list")
        this.$store.dispatch(FETCH_ARTICLES);
      }

      console.log(this.defaultParamsArticles)
    },
    resetPagination() {
      this.listConfig.skip = 0;
      this.currentPage = 1;
    },
    scroll () {
        var height1 = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight
        var height2 = document.documentElement.offsetHeight

        let bottomOfWindow = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight >= document.documentElement.offsetHeight - 30

        if (bottomOfWindow) {
          console.log("bottom")
          this.fetchArticles()
        }
    }
  }
};
</script>

<style lang="scss">
// $five-images-width: 975px;
$four-images-width: 780px;
$three-images-width: 585px;
$two-images-width: 390px;
$one-images-width: 195px;
.VPagination {
  float:left;
  width: 100%;
  margin-top: 2rem;
}
.articles {
  margin: auto;
  max-width: $one-images-width;
  overflow: hidden;
  .RwvBookTile {
    width: 100%;
    height: 275px;
  }
  @media screen and (min-width: $two-images-width) {
    max-width: $two-images-width;
    .RwvBookTile {
      width: 50%;
    }
  }
  @media screen and (min-width: $three-images-width) {
    max-width: $three-images-width;
    .RwvBookTile {
      width: 33.3%;
    }
  }
  @media screen and (min-width: $four-images-width) {
    max-width: $four-images-width;
    .RwvBookTile {
      width: 25%;
      opacity: 0.65;
      &:hover, &:active, &:focus {
        opacity: 1;
      }
    }
  }
  // @media screen and (min-width: $five-images-width) {
  //   max-width: $five-images-width;
  //   .RwvBookTile {
  //     width: 20%;
  //   }
  // }
}
</style>
